<template>
  <div class="text-center mb-2">
    <div class="d-flex align-items-center justify-content-center mb-1">
      <b-avatar :src="client.logo || null" :text="initials" size="56" variant="light-primary" rounded />
    </div>
    <h3 class="mb-50">{{ title }}</h3>
    <p class="mb-0">
      to continue to
      <b-link v-if="client.website" :href="client.website" target="_blank" rel="noopener" class="font-weight-bold">{{ client.name }}</b-link>
      <span v-else class="font-weight-bold">{{ client.name }}</span>
    </p>
  </div>
</template>

<script>
import { BAvatar, BLink } from "bootstrap-vue";

// The application asking for a PAC sign-in, shown at the top of the login and account screens,
// so the person always knows which app they are signing in to.
export default {
  components: { BAvatar, BLink },
  props: {
    client: { type: Object, required: true },
    title: { type: String, default: "Sign in" },
  },
  computed: {
    initials() {
      const words = (this.client.name || "").split(/\s+/);
      return words.map((w) => w[0] || "").join("").slice(0, 2)
        .toUpperCase();
    },
  },
};
</script>
